module.exports = __webpack_public_path__ + "static/img/btn3.a6352135.png";